// The bundled Terms of Use and the version a person accepts. The version is
// the Terms' own "Last revised" date, read from the document so a revision
// asks for acceptance again without anyone remembering to bump a constant.
import termsOfService from '@/docs/terms-of-service.md?raw';
import type { Me } from '@/lib/useMe';

const MONTHS: Record<string, string> = {
  january: '01', february: '02', march: '03', april: '04', may: '05', june: '06',
  july: '07', august: '08', september: '09', october: '10', november: '11', december: '12',
};

/** "Last revised on: September 2, 2026" → "2026-09-02". Throws if the line is missing. */
export function termsVersionOf(markdown: string): string {
  const m = /Last revised on:\s*([A-Za-z]+)\s+(\d{1,2}),\s*(\d{4})/.exec(markdown);
  const month = m ? MONTHS[m[1]!.toLowerCase()] : undefined;
  if (!m || !month) throw new Error('terms-of-service.md carries no "Last revised on: <Month> <day>, <year>" line');
  return `${m[3]}-${month}-${m[2]!.padStart(2, '0')}`;
}

export const TERMS_VERSION = termsVersionOf(termsOfService);

/** A signed-in person who has not accepted the bundled Terms is gated. */
export function needsTermsAcceptance(me: Me | undefined, isAuthenticated: boolean): boolean {
  if (!isAuthenticated || !me || me.role === 'Anonymous') return false;
  return me.terms_accepted_version !== TERMS_VERSION;
}
